/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

AOS.init({
  duration: 1500,
  once: true
});

(function($) {

  var lastScrollTop = 0;

  function watchNavigationScroll(e) {
    var st = $(window).scrollTop();

    if (e && e.type && e.type === "scroll") {
      if (st > lastScrollTop) {
        $('body').addClass('scrolled-down');
        $('body').removeClass('scrolled-up');
      }
      else {
        $('body').removeClass('scrolled-down');
        $('body').addClass('scrolled-up');
      }

      lastScrollTop = st <= 0 ? 0 : st;
    }

    if (st > 50) {
      $('body').addClass('scrolled');
    }
    else {
      $('body').removeClass('scrolled');
    }
  }

  function watchSlickDots() {
    setTimeout(function() {
      $('.slick-dots').each(function() {
        $(this).attr('data-dots-count', $(this).find('li').length);
      });
    }, 300);
  }

  jQuery.extend({
    isValidSelector: function(selector) {
      if (typeof(selector) !== 'string') {
        return false;
      }
      try {
        var $element = $(selector);
      } catch(error) {
        return false;
      }
      return true;
    }
  });

  function appHeight() {
    var doc = document.documentElement;
    doc.style.setProperty('--vh', (window.innerHeight*0.01) + 'px');
  }

  window.addEventListener('resize', appHeight);
  appHeight();
  
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        watchNavigationScroll();

        $(window).on('load resize scroll orientationchange', function (e) {
          watchNavigationScroll(e);
        });

        $('#navigation').on('show.bs.collapse', function() {
          $('body').addClass('nav-on');
        });

        $('#navigation').on('hide.bs.collapse', function() {
          $('body').removeClass('nav-on');
        });

        $('body').addClass('dom-loaded');

        $(document).on('focus', 'select', function() {
          $(this).closest('div').addClass('active-select');
        });

        $(document).on('blur', 'select', function() {
          $(this).closest('div').removeClass('active-select');
        });

        $(document).on('click', '#navigation .dropdown-toggle', function(e) {
          e.preventDefault();

          if( $('#header .navbar-toggler').is(':visible') ) {
            var sub_menu = $(this).next('.sub-menu-wrap');

            if( sub_menu.length ) {
              if( sub_menu.is(':visible') ) {
                $(this).removeClass('open');
                sub_menu.slideUp('fast');
              }
              else {
                $(this).addClass('open');
                sub_menu.slideDown('fast');
              }
            }
          }
        });

        $('.section-news-carousel .articles-carousel').each(function() {
          var t = $(this);

          if( t.find('article').length > 1 ) {
            t.slick({
              autoplay: false,
              dots: true,
              arrows: true,
              appendDots: t.closest('section').find('.articles-carousel-wrapper'),
              // appendArrows: t.closest('section').find('.articles-carousel-wrapper'),
              centerMode: true,
              centerPadding: '82px',
              responsive: [
                {
                  breakpoint: 576,
                  settings: {
                    centerPadding: '40px'
                  }
                }
              ]
            });

            setTimeout(function() {
              AOS.refresh();
            }, 500);
          }
        });

        watchSlickDots();

        $(window).on('resize', function() {
          watchSlickDots();
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
